export default {
  description: 'Sets the object filter to return all fields',
  usage: [
    'array.allData() → array',
    'object.allData() → object'
  ],
  example: {
    description: 'Set object filter to return all fields',
    code: 'v.type(\'vm\').allData()'
  }
}



// WEBPACK FOOTER //
// ./src/data/api/object_manipulation/allData.js